module.exports = __webpack_public_path__ + "img/co.7e342e02.svg";